import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { R } from '@utils/currency'

const MonthlyRetirementBudgetBucket = (props) => {
  const {
    headingText,
    maxSize,
    income,
    additionalClass
  } = props
  const bucketAmountClasses = classNames('bucket__amount', {
    'bucket__amount--outside': budgetPercentage(income, maxSize) < 35
  })

  return (
    <div className='bucket'>
      <div className='bucket__title mb-6 xs:mb-4 lg:mb-0'>
        <p>{headingText}</p>
      </div>
      <div className={`bucket__container ${additionalClass}`}>
        <div className='bucket__fill' style={{height: budgetPercentage(income, maxSize) + '%'}}>
          <div className={bucketAmountClasses}>
            <p>{R(income).format()}</p>
          </div>
        </div>
      </div>
    </div>
  )
}

MonthlyRetirementBudgetBucket.propTypes = {
  /** Monthly income value for this bucket */
  income: PropTypes.number.isRequired,
  /** Maximum income value in a set of buckets to calculate relative percentages */
  maxSize: PropTypes.number.isRequired,
  /** Textual heading for the bucket */
  headingText: PropTypes.string.isRequired,
  /** CSS class applied to the element wrapping the filled bar */
  additionalClass: PropTypes.string
}

export { MonthlyRetirementBudgetBucket }

const budgetPercentage = (current, maxSize) => {
  let percentage = Math.ceil((current / maxSize) * 100)

  if (percentage > 100) {
    percentage = 100
  }

  if (current == 0){
    percentage = 0
  }

  return percentage
}

